import styled from 'styled-components';

import {ReactNode} from 'react';

import {DrillDownColumn} from '../constants/DRILL_DOWN_COLUMN';
import {DRILL_DOWN_COLUMN_ATTRIBUTE} from '../constants/DRILL_DOWN_COLUMN_ATTRIBUTE';
import {DRILL_DOWN_TARGET_ATTRIBUTE} from '../constants/DRILL_DOWN_TARGET_ATTRIBUTE';

interface DrillDownCellProps {
  column: DrillDownColumn;
  children: ReactNode;
  isTargetRow?: boolean;
  hasUnifiedSurfaces?: boolean;
}

export function DrillDownCell(props: DrillDownCellProps) {
  if (!props.hasUnifiedSurfaces) {
    return <>{props.children}</>;
  }
  return (
    <Cell
      {...{
        [DRILL_DOWN_COLUMN_ATTRIBUTE]: props.column,
        [DRILL_DOWN_TARGET_ATTRIBUTE]: props.isTargetRow,
      }}
    >
      {props.children}
    </Cell>
  );
}

const Cell = styled.div`
  display: grid;
  align-items: center;
  min-height: ${({theme}) => theme.getSize(6)};
`;
